export default __webpack_public_path__ + "static/media/Factory-of-the-Future-Leadership.62e107fb.svg";